
import Section from 'src/components/layout-components/home-page-section.component';
import SpacerComponent from 'src/components/layout-components/spacer.component';
import HeadingComponent from 'src/components/heading-component/heading-component.component';
import ContentCardContainer from 'src/components/content-card-container/content-card-container.component';
import CountdownTimerComponent from 'src/components/countdown-timer/countdown-timer.component';
import TextLockupComponent from '../text-lockup/text-lockup.component';
import CarouselComponent from '../carousel/carousel.component';
import IconPanelComponent from '../icon-panel/icon-panel.component';
import ContentCardComponent from '../content-card/content-card.component';
import { GlobalAlertBannerComponent } from '@vaad1st/component.molecule.global-alert-banner';
import { GridComponent } from '@vaad1st/component.layout.grid';
import GridItem from '../grid-item/grid-item.component';
import { TailfinHeroBannerComponent } from '../tailfin-hero-banner/tailfin-hero-banner.component';
import { TailfinHeroBannerTwoComponent } from '../tailfin-hero-banner-two/tailfin-hero-banner-two.component';
import HotelsCarouselComponent from '../hotels-carousel/hotels-carousel.component';
import HotelsMapComponent from '../hotels-map/hotels-map.component';
import SearchPanelComponent from '../search-panel/search-panel.component';
import AccordionComponent from '../accordion/accordion-component';
import TabsComponent from '../tabs/tabs-component';
import ArticleListContainer from '../article-list-container/article-list-container.component';
import RouteMapComponent from '../route-map/route-map.component';
import LinksBanner from '../link-banner/link-banner.component';
import Breadcrumbs from '../breadcrumbs/breadcrumbs.component';
import ClimateChartComponent from '../climate-chart/climate-chart.component';
import TableCard from '../table-card/table-card.component';
import HeroBanner from '../hero-banner/hero-banner.component';
import VideoComponent from '../video-component/video-component.component';
import PromoBanner from '../promo-banner/promo-banner.component';
import ImageComponent from '../image/image.component';
import { DestinationCarouselComponent } from '../destination-carousel/destination-carousel.component';
import SlideShowComponent from '../slide-show/slide-show.component';
import FlyingDaysComponent from '../flying-days/flying-days.component';

// Renders AEM container object contents (items)
export default function PageRenderer({ items }: { items: any }) {
  if (!items || items.length === 0 || !items[0].components) return null;

  return (
    <GridComponent as="section">
      {items[0].components.map((item: any, index: any) => {
        const { C, fullWidth } = getComponent(item.componentType);
        const HOMEPAGE_SEARCH_PANEL = 'homepage-search-panel';
        const isHomepageSearchPanel =
          (item.componentProps &&
            item.componentProps.componentId === HOMEPAGE_SEARCH_PANEL) ||
          false;

        if (!C) return null;
        return (
          <GridItem
            key={`grid-item--${index}`}
            span={12}
            offset={0}
            isFullWidth={fullWidth}
            marginBottom={false}
            {...(isHomepageSearchPanel && {
              gridRow: { mobile: 1, desktop: 'auto' },
            })}
          >
            <C key={`item--${index}`} {...item.componentProps} />
          </GridItem>
        );
      })}
    </GridComponent>
  );
}

export const getComponent = (
  componentType: string
): { C: any; fullWidth: boolean } => {
  switch (componentType) {
    case 'accordion':
      return { C: AccordionComponent, fullWidth: false };
    case 'articleslist':
      return { C: ArticleListContainer, fullWidth: true };
    case 'breadcrumbs':
      return { C: Breadcrumbs, fullWidth: false };
    case 'carousel':
      return { C: CarouselComponent, fullWidth: true };
    case 'climate-chart':
      return { C: ClimateChartComponent, fullWidth: false };
    case 'container':
      return { C: Section, fullWidth: true };
    case 'content-card':
      return { C: ContentCardComponent, fullWidth: false };
    case 'content-card-container':
      return { C: ContentCardContainer, fullWidth: false };
    case 'countdown-timer':
      return { C: CountdownTimerComponent, fullWidth: true };
    case 'destination-carousel':
      return { C: DestinationCarouselComponent, fullWidth: true };
    case 'global-alert-banner':
      return { C: GlobalAlertBannerComponent, fullWidth: true };
    case 'heading-component':
      return { C: HeadingComponent, fullWidth: true };
    case 'herobanner':
      return { C: HeroBanner, fullWidth: true };
    case 'hotels-carousel':
      return { C: HotelsCarouselComponent, fullWidth: true };
    case 'hotels-map':
      return { C: HotelsMapComponent, fullWidth: false };
    case 'icon-panel':
      return { C: IconPanelComponent, fullWidth: true };
    case 'image':
      return { C: ImageComponent, fullWidth: false };
    case 'link-banner':
      return { C: LinksBanner, fullWidth: false };
    case 'promobanner':
      return { C: PromoBanner, fullWidth: true };
    case 'route-map':
      return { C: RouteMapComponent, fullWidth: false };
    case 'search-panel':
      return { C: SearchPanelComponent, fullWidth: true };
    case 'slideshow-banner':
      return { C: SlideShowComponent, fullWidth: true };
    case 'spacer-component':
      return { C: SpacerComponent, fullWidth: true };
    case 'table-card':
      return { C: TableCard, fullWidth: false };
    case 'tabs':
      return { C: TabsComponent, fullWidth: false };
    case 'tailfin-hero-banner':
      return { C: TailfinHeroBannerComponent, fullWidth: true };
    case 'tailfin-hero-banner-two':
      return { C: TailfinHeroBannerTwoComponent, fullWidth: true };
    case 'text-lockup-component':
      return { C: TextLockupComponent, fullWidth: false };
    case 'video-component':
      return { C: VideoComponent, fullWidth: false };
    case 'flying-days':
      return { C: FlyingDaysComponent, fullWidth: false };
    default:
      return { C: null, fullWidth: false };
  }
};